import _ from 'lodash';
import History from '../../util/history';
import Config from '../../config';
import Emitter from '../../services/emitter';
import { getNavigatorLang } from '../../locales';
import { translateRequestUrlForEU } from '../../util';
import CONSTANT from '../../constant';
import StoreService from './store';

// fetch polyfill
// import 'whatwg-fetch';

/**
 * Http 请求服务
 *
 * @author LiHuan
 * @export
 * @class FetchService
 */
class FetchService {
    /**
     * Creates an instance of FetchService.
     *
     * @memberOf FetchService
     */
    constructor() {
        this.store = StoreService;
        this.domainconfig = Config.domain;
    }

    /**
     * 发起 http 请求
     *
     *
     * @memberOf FetchService
     *
     * help link: https://developer.mozilla.org/zh-CN/docs/Web/API/Request/Request
     */
    request(opts) {
        if (opts.local !== true && !navigator.onLine) {
            return Promise.reject({ msg: 'not network', code: 99999 });
        }
        let req = new Request(translateRequestUrlForEU(opts.url), {
            headers: this._getReqHeader(opts.header || opts.headers),
            method: opts.method || 'POST',
            body: JSON.stringify(opts.body),
            cache: 'no-cache',
            // mode: 'no-cors',
            // 请求相关设置
            ...opts.req
        });
        let _fetch = fetch(req)
            .then((response) => {
                if (!response.ok) {
                    return Promise.reject({
                        code: response.status
                    });
                }
                return new Promise((resolve, reject) => {
                    if (opts.loadJosn) {
                        resolve(response.json());
                    } else if (opts.isNotCheckRes) {
                        resolve(response.text());
                    } else {
                        response.json().then(data => {
                            if (opts.forceData) {
                                return resolve(data);
                            }
                            if (data.code === 0) {
                                resolve(data.data);
                            } else if (data.code === 20001) {
                                resolve({
                                    token: this.store.get(CONSTANT.USER_ACCESS_TOKEN_KEY),
                                    user: this.store.get(CONSTANT.USER_INFO_KEY)
                                });
                                Emitter.emit('RepeatAuth');
                            } else {
                                if (data.code === 30001 || data.code === 20002) {
                                    this.store.remove(CONSTANT.USER_ACCESS_TOKEN_KEY);
                                    this.store.remove(CONSTANT.USER_INFO_KEY);
                                    if (opts.redirectLogin !== false) {
                                        History.push('/login');
                                    }
                                }
                                reject(data);
                            }
                        }, err => reject(err));
                    }
                });
            }, err => Promise.reject(err))
            .catch(err => {
                if (err && !err.code) {
                    err = { code: 99999 };
                }
                return Promise.reject(err);
            });
        return this.setReqTimeout(_fetch, opts.timeout || 60000);
    }

    /**
     * 数据转换
     *
     * @param {any} data
     * @returns
     *
     * @memberOf FetchService
     */
    translateToFormData(data) {
        if (data) {
            let formData = new FormData();
            for (let key in data) {
                formData.append(key, data[key]);
            }
            return formData;
        } else {
            return null;
        }
    }

    /**
     * 设置请求头
     *
     *
     * @memberOf FetchService
     */
    _setReqHeader(headers) {
        let header = new Headers();
        let headerConfig = headers;
        if (_.isFunction(headers)) {
            headerConfig = headers();
        }
        headerConfig = Object.assign({}, {
            'accesstoken': this.store.get(CONSTANT.USER_ACCESS_ACCESSTOKEN_KEY),
            'utoken': this.store.get(CONSTANT.USER_ACCESS_UTOKEN_KEY),
            'token': this.store.get(CONSTANT.USER_ACCESS_TOKEN_KEY),
            'lang': this.store.get(CONSTANT.INTL_LANG_KEY) || getNavigatorLang(),
            'content-type': 'application/json; charset=utf-8'
        }, headerConfig);
        for (let key in headerConfig) {
            header.append(key, headerConfig[key]);
        }
        return header;
    }

    /**
     * 获取请求头设置
     *
     * @returns
     *
     * @memberOf FetchService
     */
    _getReqHeader(headers) {
        return this._setReqHeader(headers);
    }

    /**
     * 取消请求
     *
     * @param {any} abortablePromise
     *
     * @memberOf FetchService
     */
    cancelReq(abortablePromise) {
        abortablePromise.abort && abortablePromise.abort();
    }

    /**
     * 设置请求超时
     *
     * @param {any} promise
     * @param {number} [timeout=6000]
     * @returns
     *
     * @memberOf FetchService
     */
    setReqTimeout(promise, timeout = 6000) {
        let abortablePromise = this.abortablePromise(promise);
        let timer = setTimeout(() => {
            if (!abortablePromise.isAbort) {
                abortablePromise.abort && abortablePromise.abort();
            }
            clearTimeout(timer);
        }, timeout);
        return abortablePromise;
    }

    /**
     * 终止请求的 Promise
     *
     * @param {any} fetchPromise
     * @returns
     *
     * @memberOf FetchService
     */
    abortablePromise(fetchPromise) {
        let abortFn = null;
        let isAbort = false;

        // 这是一个可以被reject的promise
        let abortPromise = new Promise((resolve, reject) => {
            abortFn = () => {
                isAbort = true;
                reject('abort promise');
            };
        });

        // 这里使用Promise.race，以最快 resolve 或 reject 的结果来传入后续绑定的回调
        var abortablePromise = Promise.race([
            fetchPromise,
            abortPromise
        ]);

        abortablePromise.abort = abortFn;
        abortablePromise.isAbort = isAbort;

        return abortablePromise;
    }

    /**
      * 将配置转换为请求的操作
      *
      *
      * @memberOf FetchService
      */
    configToRequestAction(apisConfig, engine) {
        for (var key in apisConfig) {
            let config = apisConfig[key];
            this[key] = function () {
                let opts = { ...config };
                let argIdx = 0;
                let requsetUrl = typeof config.url === 'function' ? config.url() : config.url;
                if (arguments.length > 0) {
                    const arg = arguments[0];
                    if (arg && arg.hasOwnProperty('_HEADER_')) {
                        const header = opts.header || opts.headers;
                        opts.header = Object.assign({}, header, arg['_HEADER_']);
                        delete arg['_HEADER_'];
                    }
                }
                if (requsetUrl.indexOf(':') >= 0) {
                    let params = requsetUrl.match(/(:[^{:&/|_}]*)/g);
                    // 替换参数的值
                    params.map((param, idx) => {
                        requsetUrl = requsetUrl.replace(param, arguments[idx]);
                    });
                    argIdx = params.length;
                }
                if (config.domain) {
                    opts.url = config.domain + requsetUrl;
                } else {
                    opts.url = config.local ? requsetUrl : (this.domain + requsetUrl);
                }
                if (opts.method.toUpperCase() === 'PUT' || opts.method.toUpperCase() === 'POST' && arguments.length > 0) {
                    if (arguments[argIdx]) {
                        opts.body = arguments[argIdx];
                    }
                }
                return engine.request(opts);
            };
        }
    }

}

export default new FetchService();